import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
  LEGACY_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./GpiCouponFormConfig";
import { LegacyResolvers } from "../../common_nextgen/utils/UtilFunctions";
import { getUpdatedPreviousState } from "../../common_nextgen/utils/UtilFunctions";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const screenInfo = {
  ADD: ["Add GPI to Coupon Patient Pay GPI List", "RCCPG002"],
  CHANGE: ["GPI in Coupon Patient Pay GPI List Detail", "RCCPG003"],
  VIEW: ["GPI in Coupon Patient Pay GPI List Detail", "RCCPG003"],
};

const GpiCouponForm = ({ mode }) => {
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    selectedSteps = [],
    previousScreen = ROUTE_PATHS.COUPON_PATIENT_PAY_GPI,
    currentIndex: initialIndex = 0,
    lookupScreen,
    lookupParams,
    lookupMode: initialLookupMode = false,
    formData: baseFormData = {},
    navigateData,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  /* const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});

  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };*/

  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialFormData,
    initialLookupMode,
    lookupParams,
    lookupScreen,
    previousState,
    currentState,
    initialIndex,
    navigateData,
  });

  const handleBack = () => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitFormData = (data) => {
    setDataForSubmission(data);
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/cpgCouponPatPayGpiDtl";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/cpgCouponPatPayGpiDtl";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
          infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                          toast.current.show({
                                            severity: "info",
                                            summary: "",
                                            detail: responseStatus.message,
                                            life: 3000,
                                          });
                                        } else {
                                          toast.current.show({
                                            severity: "success",
                                            summary: "",
                                            detail: responseStatus.message,
                                            life: 3000,
                                          });

      setInitialFormData({
        ...responseData,
        cpfGpiListDescription: selectedSchedules[0].cpfGpiListDescription,
      });
      
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        setLookupMode(false);
        const updatedPreviousState = getUpdatedPreviousState(previousState, {
          cpgGenericProductId: responseData.cpgGenericProductId,
        });
        const updatedCurrentState = {
          ...currentState,
          selectedSteps: [
            {
              ...responseData,
              cpfGpiListDescription: selectedSchedules[0].cpfGpiListDescription,
            },
          ],
          currentIndex: 0,
          lookupMode: false,
        };
        navigateToPage(ROUTE_PATHS.EDIT_COUPON_PATIENT_PAY_GPI_LIST, [
          ...updatedPreviousState,
          { ...updatedCurrentState },
        ]);
      }
    } }catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      // keyFunc.Enter = submitFormData;
      // keyName.Enter = 'Save';
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      // keyFunc.Enter = submitFormData;
      // keyName.Enter = 'Save';
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
        setLookupMode(false);
      };
      keyName.chmod = "View";
      keyFunc.F14 = () =>
        navigateToPage(ROUTE_PATHS.NOTE_GPI_COUPON_PATIENT_PAY, [
          ...previousState,
          { ...currentState, currentIndex, lookupMode: false },
          {
            selectedPriceSchedules: [selectedSteps[currentIndex]],
            selectedSchedules: selectedSchedules,
            currentIndex: 0,
            previousScreen: location.pathname,
            paramsData,
          },
        ]);
      keyName.F14 = "Note";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F14 = () =>
        navigateToPage(ROUTE_PATHS.NOTE_GPI_COUPON_PATIENT_PAY, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedPriceSchedules: [selectedSteps[currentIndex]],
            selectedSchedules: selectedSchedules,
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      keyName.F14 = "Note";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, initialFormData]);

  const paramsData = {
    cpfGpiListName: selectedSchedules[0].cpfGpiListName,
    cpfGpiListDescription: selectedSchedules[0].cpfGpiListDescription,
    cpgGenericProductId: selectedSteps[currentIndex].cpgGenericProductId,
    cpgSequence: selectedSteps[currentIndex].cpgSequence,
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      const url = isAddMode(currentMode)
        ? `api/cpgCouponPatPayGpiDtl/initialFormData/${screenInfo.ADD[1]}`
        : `api/cpgCouponPatPayGpiDtl/${encodeURIComponent(
            selectedSteps[currentIndex].cpfGpiListName
          )}`;
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        {},
        paramsData
      );
      setInitialFormData({ ...responseData, ...paramsData });
    };

    if (initialLookupMode && Object.keys(baseFormData).length) {
      setInitialFormData(baseFormData);
    } else {
      fetchInitialData();
    }
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default GpiCouponForm;
